import { Calculation } from 'final-form-calculate'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { CitopatologicoPerguntaField, RequisicaoExameCitopatologicoFormValues } from './model-citopatologico'

export const createCitopatologicoCalculations = (
  meta: MetaRoot<RequisicaoExameCitopatologicoFormValues>
): Calculation[] => [checkDumCalculator(meta), fezPreventivoCalculator(meta)]

const checkDumCalculator = (meta: MetaRoot<RequisicaoExameCitopatologicoFormValues>): Calculation => ({
  field: meta.checkDum.absolutePath(),
  updates: {
    [meta[CitopatologicoPerguntaField.dum].absolutePath()]: (checkDumValue: boolean) => {
      if (checkDumValue === true) {
        return null
      }
    },
  },
})

const fezPreventivoCalculator = (meta: MetaRoot<RequisicaoExameCitopatologicoFormValues>): Calculation => ({
  field: meta[CitopatologicoPerguntaField.examePreventivo].absolutePath(),
  updates: {
    [meta[CitopatologicoPerguntaField.dataPreventivo].absolutePath()]: (examePreventivoValue: string) => {
      if (
        examePreventivoValue === RastreioCancerPerguntaOpcaoEnum.NAO ||
        examePreventivoValue === RastreioCancerPerguntaOpcaoEnum.NAO_INFORMADO
      ) {
        return null
      }
    },
  },
})
